import { ActionsMenu, ActionsMenuItem } from '@/components/ActionsMenu';
import TrashIcon from '@/components/Icons/TrashIcon';

import { useDeleteTrainingProject } from '../hooks';
import { ActionsProps } from './types';

function Actions({ trainingProject, variant }: ActionsProps) {
  const deleteTrainingProject = useDeleteTrainingProject(trainingProject.id, trainingProject.name);

  return (
    <ActionsMenu variant={variant}>
      <ActionsMenuItem destructive onClick={deleteTrainingProject} icon={<TrashIcon />}>
        Delete training project
      </ActionsMenuItem>
    </ActionsMenu>
  );
}

export default Actions;
